import { DestinationItemType } from '@tableau/nested-project-explorer';

import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, QuotaErrorCode,TagErrorCode, WorkbookErrorCode} from '~commonInfra/utils/ErrorCodes';
import {SessionSiteSelectors} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { IWorkbookBase } from '../models/IWorkbookInfo';


function errorDetailsFor(workbookErrorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
  return {
    itemName: workbookErrorItem.item.name,
    itemUrl:
      workbookErrorItem.error.code === CommonErrorCode.WorkbookNotFound
        ? null
        : workbookUrl(workbookErrorItem.item),
    errorMessage: errorMessageFor(workbookErrorItem)
  };
}

function workbookUrl(workbook: IWorkbookBase): string {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return siteUrls ? siteUrls.workbookUrl(workbook.id) : '';
}

function errorMessageFor(errorItem: IErrorItem<IWorkbookBase>) {
  const workbook = errorItem.item;
  switch (errorItem.error.code) {
    case WorkbookErrorCode.WorkbookDescriptionTooLong:
      return Messages.errorWorkbookDescriptionTooLong({ MAX_LENGTH: L10n.localizedCount(getSessionManagementServiceInstance().maxDescriptionLength()) });
    case CommonErrorCode.WorkbookNotFound:
      return Messages.errorWorkbookNotFound({ WORKBOOK_NAME: L10n.elideIfLong(workbook.name) });
    case WorkbookErrorCode.WorkbookDisabled:
      return Messages.errorWorkbookDisabled({ WORKBOOK_NAME: L10n.elideIfLong(workbook.name) });
    case WorkbookErrorCode.WorkbookNameAlreadyExistsInDestinationProject:
      return Messages.errorWorkbookNameAlreadyExistsInDestinationProject();
    case WorkbookErrorCode.WorkbookDestinationProjectNotFound:
      return Messages.errorWorkbookDestinationProjectNotFound();
    case WorkbookErrorCode.WorkbookNameAlreadyExists:
      return Messages.errorWorkbookNameAlreadyExists();
    case TagErrorCode.TooManyTags:
      return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
    // Permissions errors
    // TODO: Do we want specific error messages for each of these cases?
    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnDestinationProject:
    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnSourceProject:
    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnWorkbook:
      return Messages.errorWorkbookMoveInsufficientPermissions();
    case CommonErrorCode.CallingUserInsufficientPermissions:
      return Messages.errorWorkbookInsufficientPermissions();
    case WorkbookErrorCode.WorkbookChangeOwnerNotAllowedInPersonalSpace:
      return Messages.changeOwnerContentItems_notAllowedInPersonalSpaceError();
    default:
      return Messages.errorUnknown();
  }
}

function moveContentToContainerErrorMessageDetailsFor(workbookErrorItem: IErrorItem<IWorkbookBase>, destinationType: DestinationItemType): IErrorDetail {
  return {
    itemName: workbookErrorItem.item.name,
    itemUrl:
      workbookErrorItem.error.code === CommonErrorCode.WorkbookNotFound
        ? null
        : workbookUrl(workbookErrorItem.item),
    errorMessage: moveContentToContainerErrorMessageFor(workbookErrorItem, destinationType)
  };
}

function moveContentToContainerErrorMessageFor(errorItem: IErrorItem<IWorkbookBase>, destinationType: DestinationItemType) {
  const workbook = errorItem.item;
  switch (errorItem.error.code) {
    case CommonErrorCode.WorkbookNotFound:
      return Messages.errorWorkbookNotFound({ WORKBOOK_NAME: L10n.elideIfLong(workbook.name) });
    case WorkbookErrorCode.WorkbookNameAlreadyExistsInDestinationProject:
      return destinationType === DestinationItemType.personalSpace ?
         Messages.errorWorkbookNameAlreadyExistsInPersonalSpace():
         Messages.errorWorkbookNameAlreadyExistsInDestinationProject();

    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnDestinationProject:
    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnSourceProject:
    case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnWorkbook:
    case CommonErrorCode.MoveInsufficientPermissionsOnContent:
        Messages.errorWorkbookMoveInsufficientPermissions();
    case CommonErrorCode.CallingUserInsufficientPermissions:
      return Messages.errorWorkbookInsufficientPermissions();
    case QuotaErrorCode.CONTAINER_STORAGE_QUOTA_LIMIT_EXCEEDED:
      return Messages.personalSpaceStorageQuotaError();
    default:
      return Messages.errorUnknown();
  }
}


export const WorkbookErrors = {
  errorDetailsFor,
  errorMessageFor,
  moveContentToContainerErrorMessageDetailsFor
};

// Easy type definition that is used in some cases.
export type WorkbookErrors = typeof WorkbookErrors;
